import { Keys } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";

export class AdvancedSearchButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonAdvancedSearch`,
            variant: ButtonVariant.round,
            imageName: ImageName.magnifyingGlassPage,
            hotkey: "Alt-S",
            onClick: () => this.table.crudManager.showSearch(),
            tooltip: "Show advanced search options (Alt-S)"
        });
        this.button.addHandlerForKey(Keys.S, { altKey: true });
    }
}
